/**
 * Global Navigation state
 */
export interface NavigationState {
  hamburgerMenuOpen: boolean;
}

export const initialNavigationState: NavigationState = {
  hamburgerMenuOpen: false,
};
